import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import * as S from "./style";
var antIcon = React.createElement(LoadingOutlined, { style: { fontSize: 64 }, spin: true });
var Loading = function (props) {
    return props.pastDelay ? (React.createElement(S.Container, null,
        React.createElement(Spin, { indicator: antIcon }))) : null;
};
export var LoadingCover = function () {
    return (React.createElement(S.LoadingCover, null,
        React.createElement(Spin, { indicator: antIcon })));
};
export default Loading;
